import {
  AssessmentOutlined,
  CheckCircleOutline,
  EventBusyOutlined,
  PublishedWithChangesOutlined,
  RuleOutlined,
  SupervisorAccountOutlined,
  TipsAndUpdatesOutlined,
} from '@mui/icons-material';
import { IMenu } from '@dfl/mui-react-common';
import { WAREHOUSE_PERMISSIONS } from 'modules/inventory/warehouse/constants';
import { ORDER_PERMISSIONS, SUBORDER_PERMISSIONS } from 'modules/sales/common/constants/order-permissions';
import {
  NotPaidOrderIcon,
  OfferIcon,
  OrderIcon,
  OrderIssuesIcon,
  SubOrderIcon,
} from 'modules/sales/common/components/icons';
import { CAUSES_INCIDENCE_PERMISSIONS } from 'modules/sales/settings/causes-incidence/constants';
import { ORDER_STATUS_PERMISSIONS } from 'modules/sales/settings/order-status/constants';
import { DispatchIcon } from 'modules/sales/common/components/icons/DispatchIcon';
import { DISPATCH_PERMISSIONS } from 'modules/sales/dispatch/constants';
import { INCIDENCE_PERMISSIONS } from 'modules/sales/incidence/constants';
import { RESOLUTION_STATUS_PERMISSIONS } from 'modules/sales/settings/resolution-status/constants/resolution-status.permissions';
import { OFFER_PERMISSIONS } from 'modules/sales-offer/offer/constants';
import { UnPaidOrderPermissions } from 'modules/sales/pre-order/constants/pre-orders.permissions';
import { INCIDENCE_RESOLUTION_PERMISSIONS } from 'modules/sales/incidence-resolution/constants';
import { disabledCustomerActions, disabledResolutionStatus } from 'utils/flags-utils';
import { CUSTOMER_CARE_ACTION_PERMISSIONS } from 'modules/reports/constants/customer-care.permissions';

export const SALES_MENU: IMenu[] = [
  {
    title: 'main_menu.admin.section.sales.title',
    prefix: '/sales',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.sales.paid-orders',
        path: '/sales/orders',
        partialMatch: true,
        icon: <OrderIcon fontSize='small' />,
        permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.Suborders',
        path: '/sales/sub-orders',
        partialMatch: true,
        icon: <SubOrderIcon fontSize='small' />,
        permissions: [SUBORDER_PERMISSIONS.SUBORDER_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.dispatches',
        path: '/sales/dispatches',
        partialMatch: true,
        icon: <DispatchIcon fontSize='small' />,
        permissions: [DISPATCH_PERMISSIONS.DISPATCH_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.issues',
        path: '/sales/incidences',
        partialMatch: true,
        icon: <OrderIssuesIcon fontSize='small' />,
        permissions: [INCIDENCE_PERMISSIONS.INCIDENCE_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.resolution',
        path: '/sales/incidence-resolutions',
        partialMatch: true,
        icon: <TipsAndUpdatesOutlined fontSize='small' />,
        permissions: [INCIDENCE_RESOLUTION_PERMISSIONS.INCIDENCE_RESOLUTION_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.offers',
        path: '/sales/offers',
        partialMatch: true,
        icon: <OfferIcon fontSize='small' />,
        permissions: [OFFER_PERMISSIONS.OFFER_VIEW],
      },
      {
        title: 'main_menu.admin.section.sales.pre-orders',
        path: '/sales/pre-orders',
        partialMatch: true,
        icon: <NotPaidOrderIcon fontSize='small' />,
        permissions: [UnPaidOrderPermissions.UNPAID_ORDER_VIEW],
      },

      ...(!disabledCustomerActions
        ? [
            {
              title: 'main_menu.admin.section.sales.customer-actions',
              path: '/sales/customer-actions',
              partialMatch: true,
              icon: <SupervisorAccountOutlined fontSize='small' />,
              permissions: [CUSTOMER_CARE_ACTION_PERMISSIONS.VIEW],
            },
          ]
        : []
      ),

    ],
  },
  {
    title: 'main_menu.admin.section.general.reports',
    prefix: '/sales/reports',
    atLessOne: true,
    hidden: true,
    items: [
      {
        title: 'main_menu.admin.section.reports.paid-orders',
        path: '/sales/reports/orders',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.sales.Suborders',
        path: '/sales/reports/sub-orders',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW],
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.sales.issues',
        path: '/sales/reports/incidences',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW],
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.sales.refunds',
        path: '/sales/reports/refunds',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW],
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.sales.offers',
        path: '/sales/reports/offers',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW],
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.sales.pre-orders',
        path: '/sales/reports/pre-orders',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        permissions: [ORDER_PERMISSIONS.ORDER_VIEW],
        disabled: true,
      },
    ],
  },
  {
    title: 'main_menu.admin.section.general.settings',
    prefix: '/sales/settings',
    atLessOne: true,
    items: [
      ...(!disabledCustomerActions
        ? [
            {
              title: 'main_menu.admin.section.sales.customerCare',
              path: '/sales/settings/customer-care',
              partialMatch: true,
              icon: <RuleOutlined fontSize='small' />,
            },
          ]
        : []
      ),
      {
        title: 'orderStatus:list',
        path: '/sales/settings/order-status',
        partialMatch: true,
        icon: <PublishedWithChangesOutlined fontSize='small' />,
        permissions: [ORDER_STATUS_PERMISSIONS.ORDER_STATUS_VIEW],
      },
      ...(!disabledResolutionStatus
        ? [
            {
              title: 'resolutionStatus:list',
              path: '/sales/settings/resolution-status',
              partialMatch: true,
              icon: <CheckCircleOutline fontSize='small' />,
              permissions: [RESOLUTION_STATUS_PERMISSIONS.RESOLUTION_STATUS_VIEW],
            },
          ]
        : []),
      {
        title: 'causesIncidence:list',
        path: '/sales/settings/causes-incidence',
        partialMatch: true,
        icon: <EventBusyOutlined fontSize='small' />,
        permissions: [CAUSES_INCIDENCE_PERMISSIONS.CAUSES_INCIDENCE_VIEW],
      },
    ],
  },
];
